import styled from "styled-components";

const ACTIVE_SECTION_COLOR = '#CC214F';
const ACTIVE_SECTION_COLOR_SHADOW = 'rgba(204, 33, 79, 0.35)';
const INACTIVE_SECTION_COLOR = '#908B8B';
const OUTDATED_SECTION_COLOR = '#000000';

export const SectionHeaderRoot = styled.div<{$isCurrent?: boolean; $isExpanded?: boolean; $isOutdated?: boolean;}>`
    width: auto;
    height: 5em;
    border: 2px solid ${(props) => props.$isCurrent ? ACTIVE_SECTION_COLOR_SHADOW : 'transparent'};
    background-color: ${(props) =>
    {
        if(props.$isOutdated)
        {
            return OUTDATED_SECTION_COLOR;
        }

        return props.$isCurrent ? ACTIVE_SECTION_COLOR : INACTIVE_SECTION_COLOR;
    }};
    border-radius: ${(props) => props.$isExpanded ? '12px 12px 0 0' : '12px'};
    text-align: center;
    cursor: pointer;
    box-shadow: ${(props) => props.$isCurrent
        ? `2px 2px 2px 1px ${ACTIVE_SECTION_COLOR_SHADOW}`
        : '2px 2px 2px 1px rgba(0, 0, 0, 0.2)'};
`;

export const SectionHeaderText = styled.div`
    color: white;
    padding-top: 0.7em;
    font-size: 25px;
    font-weight: 600;
`;